  const predefinedThemes = [
    {
      id: 1,
      name: "Royal Gold",
      colors: {
        "--font-primary": '"Merriweather", serif',
        "--color-primary-dark": "#0b090a",
        "--color-primary-light": "#fffdf7",
        "--color-accent-yellow": "#d4af37",
        "--header-bg-start": "#3a3a3a",
        "--header-bg-end": "#0b090a",
        "--header-border-color": "#d4af37",
        "--sidebar-bg-start": "#1a1a1a",
        "--sidebar-bg-end": "#3d2c00",
        "--sidebar-text-color": "#f0e6d2",
        "--sidebar-icon-color": "#f0e6d2",
        "--sidebar-active-bg": "#d4af37",
        "--sidebar-active-text-color": "#0b090a",
        "--location-switcher-bg": "#f8f3e7",
        "--location-switcher-text-color": "#3d2c00",
        "--location-switcher-icon-color": "#3d2c00",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#b08d57",
        "--sidebar-scrollbar-thumb-color": "#d4af37",
        "--sidebar-scrollbar-track-color": "#0b090a",
        "--card-bg-color": "#fffdf7",
        "--card-border-color": "#d4af37",
        "--card-shadow": "rgba(212, 175, 55, 0.2) 0px 3px 10px",
        "--button-bg-color": "#d4af37",
        "--button-border-color": "#d4af37",
        "--button-text-color": "#0b090a",
        "--button-hover-bg": "#ffda76",
        "--button-hover-text-color": "#0b090a",
        "--graph-open-col-fill": "#ffd700",
      },
    },
    {
      id: 2,
      name: "Ocean Blue",
      colors: {
        "--font-primary": '"Inter", sans-serif',
        "--color-primary-dark": "#012a4a",
        "--color-primary-light": "#e0fbfc",
        "--color-accent-yellow": "#00b4d8",
        "--header-bg-start": "#0077b6",
        "--header-bg-end": "#023e8a",
        "--header-border-color": "#90e0ef",
        "--sidebar-bg-start": "#03045e",
        "--sidebar-bg-end": "#023e8a",
        "--sidebar-text-color": "#caf0f8",
        "--sidebar-icon-color": "#ade8f4",
        "--sidebar-active-bg": "#00b4d8",
        "--sidebar-active-text-color": "#012a4a",
        "--location-switcher-bg": "#caf0f8",
        "--location-switcher-text-color": "#03045e",
        "--location-switcher-icon-color": "#03045e",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#0077b6",
        "--sidebar-scrollbar-thumb-color": "#00b4d8",
        "--sidebar-scrollbar-track-color": "#012a4a",
        "--card-bg-color": "#e0fbfc",
        "--card-border-color": "#00b4d8",
        "--card-shadow": "rgba(0, 180, 216, 0.2) 0px 3px 10px",
        "--button-bg-color": "#00b4d8",
        "--button-border-color": "#00b4d8",
        "--button-text-color": "#012a4a",
        "--button-hover-bg": "#90e0ef",
        "--button-hover-text-color": "#012a4a",
        "--graph-open-col-fill": "#0077b6",
      },
    },
    {
      id: 3,
      name: "Deep Navy",
      colors: {
        "--font-primary": '"Roboto", sans-serif',
        "--color-primary-dark": "#1b262c",
        "--color-primary-light": "#f0f5f9",
        "--color-accent-yellow": "#3282b8",
        "--header-bg-start": "#0f4c75",
        "--header-bg-end": "#1b262c",
        "--header-border-color": "#bbe1fa",
        "--sidebar-bg-start": "#1b262c",
        "--sidebar-bg-end": "#0f4c75",
        "--sidebar-text-color": "#bbe1fa",
        "--sidebar-icon-color": "#bbe1fa",
        "--sidebar-active-bg": "#3282b8",
        "--sidebar-active-text-color": "#f0f5f9",
        "--location-switcher-bg": "#bbe1fa",
        "--location-switcher-text-color": "#1b262c",
        "--location-switcher-icon-color": "#1b262c",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#3282b8",
        "--sidebar-scrollbar-thumb-color": "#3282b8",
        "--sidebar-scrollbar-track-color": "#1b262c",
        "--card-bg-color": "#f0f5f9",
        "--card-border-color": "#3282b8",
        "--card-shadow": "rgba(50, 130, 184, 0.2) 0px 3px 10px",
        "--button-bg-color": "#3282b8",
        "--button-border-color": "#3282b8",
        "--button-text-color": "#ffffff",
        "--button-hover-bg": "#bbe1fa",
        "--button-hover-text-color": "#1b262c",
        "--graph-open-col-fill": "#0f4c75",
      },
    },
    {
      id: 4,
      name: "Berry Pink",
      colors: {
        "--font-primary": '"Open Sans", sans-serif',
        "--color-primary-dark": "#2d132c",
        "--color-primary-light": "#ffe8d6",
        "--color-accent-yellow": "#ff8fab",
        "--header-bg-start": "#801336",
        "--header-bg-end": "#2d132c",
        "--header-border-color": "#ff8fab",
        "--sidebar-bg-start": "#2d132c",
        "--sidebar-bg-end": "#801336",
        "--sidebar-text-color": "#ffe8d6",
        "--sidebar-icon-color": "#ffe8d6",
        "--sidebar-active-bg": "#ff8fab",
        "--sidebar-active-text-color": "#2d132c",
        "--location-switcher-bg": "#ffe8d6",
        "--location-switcher-text-color": "#2d132c",
        "--location-switcher-icon-color": "#2d132c",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#ff8fab",
        "--sidebar-scrollbar-thumb-color": "#ff8fab",
        "--sidebar-scrollbar-track-color": "#2d132c",
        "--card-bg-color": "#ffe8d6",
        "--card-border-color": "#ff8fab",
        "--card-shadow": "rgba(255, 143, 171, 0.2) 0px 3px 10px",
        "--button-bg-color": "#ff8fab",
        "--button-border-color": "#ff8fab",
        "--button-text-color": "#2d132c",
        "--button-hover-bg": "#ffd6e0",
        "--button-hover-text-color": "#2d132c",
        "--graph-open-col-fill": "#801336",
      },
    },
    {
      id: 5,
      name: "Emerald Teal",
      colors: {
        "--font-primary": '"Nunito", sans-serif',
        "--color-primary-dark": "#001219",
        "--color-primary-light": "#e9d8a6",
        "--color-accent-yellow": "#005f73",
        "--header-bg-start": "#0a9396",
        "--header-bg-end": "#001219",
        "--header-border-color": "#94d2bd",
        "--sidebar-bg-start": "#001219",
        "--sidebar-bg-end": "#005f73",
        "--sidebar-text-color": "#e9d8a6",
        "--sidebar-icon-color": "#e9d8a6",
        "--sidebar-active-bg": "#0a9396",
        "--sidebar-active-text-color": "#001219",
        "--location-switcher-bg": "#94d2bd",
        "--location-switcher-text-color": "#001219",
        "--location-switcher-icon-color": "#001219",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#0a9396",
        "--sidebar-scrollbar-thumb-color": "#0a9396",
        "--sidebar-scrollbar-track-color": "#001219",
        "--card-bg-color": "#e9d8a6",
        "--card-border-color": "#0a9396",
        "--card-shadow": "rgba(10, 147, 150, 0.2) 0px 3px 10px",
        "--button-bg-color": "#0a9396",
        "--button-border-color": "#0a9396",
        "--button-text-color": "#001219",
        "--button-hover-bg": "#94d2bd",
        "--button-hover-text-color": "#001219",
        "--graph-open-col-fill": "#005f73",
      },
    },
    {
      id: 6,
      name: "Royal Purple",
      colors: {
        "--font-primary": '"Raleway", sans-serif',
        "--color-primary-dark": "#240046",
        "--color-primary-light": "#f8edeb",
        "--color-accent-yellow": "#ffb703",
        "--header-bg-start": "#7209b7",
        "--header-bg-end": "#240046",
        "--header-border-color": "#f72585",
        "--sidebar-bg-start": "#240046",
        "--sidebar-bg-end": "#3a0ca3",
        "--sidebar-text-color": "#f8edeb",
        "--sidebar-icon-color": "#f8edeb",
        "--sidebar-active-bg": "#f72585",
        "--sidebar-active-text-color": "#240046",
        "--location-switcher-bg": "#f8edeb",
        "--location-switcher-text-color": "#240046",
        "--location-switcher-icon-color": "#240046",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#f72585",
        "--sidebar-scrollbar-thumb-color": "#f72585",
        "--sidebar-scrollbar-track-color": "#240046",
        "--card-bg-color": "#f8edeb",
        "--card-border-color": "#f72585",
        "--card-shadow": "rgba(247, 37, 133, 0.2) 0px 3px 10px",
        "--button-bg-color": "#f72585",
        "--button-border-color": "#f72585",
        "--button-text-color": "#f8edeb",
        "--button-hover-bg": "#ffb703",
        "--button-hover-text-color": "#240046",
        "--graph-open-col-fill": "#3a0ca3",
      },
    },
    {
      id: 7,
      name: "Golden Black",
      colors: {
        "--font-primary": '"Manrope", sans-serif',
        "--color-primary-dark": "#14213d",
        "--color-primary-light": "#fca311",
        "--color-accent-yellow": "#e5e5e5",
        "--header-bg-start": "#000000",
        "--header-bg-end": "#14213d",
        "--header-border-color": "#fca311",
        "--sidebar-bg-start": "#14213d",
        "--sidebar-bg-end": "#000000",
        "--sidebar-text-color": "#e5e5e5",
        "--sidebar-icon-color": "#e5e5e5",
        "--sidebar-active-bg": "#fca311",
        "--sidebar-active-text-color": "#14213d",
        "--location-switcher-bg": "#e5e5e5",
        "--location-switcher-text-color": "#14213d",
        "--location-switcher-icon-color": "#14213d",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#fca311",
        "--sidebar-scrollbar-thumb-color": "#fca311",
        "--sidebar-scrollbar-track-color": "#000000",
        "--card-bg-color": "#fca311",
        "--card-border-color": "#14213d",
        "--card-shadow": "rgba(252, 163, 17, 0.3) 0px 3px 10px",
        "--button-bg-color": "#fca311",
        "--button-border-color": "#fca311",
        "--button-text-color": "#14213d",
        "--button-hover-bg": "#e5e5e5",
        "--button-hover-text-color": "#14213d",
        "--graph-open-col-fill": "#14213d",
      },
    },
    {
      id: 8,
      name: "Crimson Blue",
      colors: {
        "--font-primary": '"Montserrat", sans-serif',
        "--color-primary-dark": "#1e1e24",
        "--color-primary-light": "#f8f9fa",
        "--color-accent-yellow": "#e63946",
        "--header-bg-start": "#457b9d",
        "--header-bg-end": "#1d3557",
        "--header-border-color": "#e63946",
        "--sidebar-bg-start": "#1d3557",
        "--sidebar-bg-end": "#457b9d",
        "--sidebar-text-color": "#f1faee",
        "--sidebar-icon-color": "#f1faee",
        "--sidebar-active-bg": "#e63946",
        "--sidebar-active-text-color": "#f8f9fa",
        "--location-switcher-bg": "#f1faee",
        "--location-switcher-text-color": "#1d3557",
        "--location-switcher-icon-color": "#1d3557",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#e63946",
        "--sidebar-scrollbar-thumb-color": "#e63946",
        "--sidebar-scrollbar-track-color": "#1e1e24",
        "--card-bg-color": "#f8f9fa",
        "--card-border-color": "#e63946",
        "--card-shadow": "rgba(230, 57, 70, 0.2) 0px 3px 10px",
        "--button-bg-color": "#e63946",
        "--button-border-color": "#e63946",
        "--button-text-color": "#f8f9fa",
        "--button-hover-bg": "#f1faee",
        "--button-hover-text-color": "#1d3557",
        "--graph-open-col-fill": "#457b9d",
      },
    },
    {
      id: 9,
      name: "Slate Gray",
      colors: {
        "--font-primary": '"Work Sans", sans-serif',
        "--color-primary-dark": "#0d1b2a",
        "--color-primary-light": "#e0e1dd",
        "--color-accent-yellow": "#778da9",
        "--header-bg-start": "#1b263b",
        "--header-bg-end": "#0d1b2a",
        "--header-border-color": "#778da9",
        "--sidebar-bg-start": "#0d1b2a",
        "--sidebar-bg-end": "#1b263b",
        "--sidebar-text-color": "#e0e1dd",
        "--sidebar-icon-color": "#e0e1dd",
        "--sidebar-active-bg": "#778da9",
        "--sidebar-active-text-color": "#0d1b2a",
        "--location-switcher-bg": "#e0e1dd",
        "--location-switcher-text-color": "#0d1b2a",
        "--location-switcher-icon-color": "#0d1b2a",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#778da9",
        "--sidebar-scrollbar-thumb-color": "#778da9",
        "--sidebar-scrollbar-track-color": "#0d1b2a",
        "--card-bg-color": "#e0e1dd",
        "--card-border-color": "#778da9",
        "--card-shadow": "rgba(119, 141, 169, 0.2) 0px 3px 10px",
        "--button-bg-color": "#778da9",
        "--button-border-color": "#778da9",
        "--button-text-color": "#0d1b2a",
        "--button-hover-bg": "#e0e1dd",
        "--button-hover-text-color": "#0d1b2a",
        "--graph-open-col-fill": "#1b263b",
      },
    },
    {
      id: 10,
      name: "Crimson Dark",
      colors: {
        "--font-primary": '"Lato", sans-serif',
        "--color-primary-dark": "#161a1d",
        "--color-primary-light": "#f8f9fa",
        "--color-accent-yellow": "#ba181b",
        "--header-bg-start": "#660708",
        "--header-bg-end": "#161a1d",
        "--header-border-color": "#ba181b",
        "--sidebar-bg-start": "#161a1d",
        "--sidebar-bg-end": "#660708",
        "--sidebar-text-color": "#f8f9fa",
        "--sidebar-icon-color": "#f8f9fa",
        "--sidebar-active-bg": "#ba181b",
        "--sidebar-active-text-color": "#f8f9fa",
        "--location-switcher-bg": "#f8f9fa",
        "--location-switcher-text-color": "#161a1d",
        "--location-switcher-icon-color": "#161a1d",
        "--sidebar-action-button-bg": "#ffffff",
        "--sidebar-action-button-text-color": "#000000",
        "--scrollbar-thumb-color": "#ba181b",
        "--sidebar-scrollbar-thumb-color": "#ba181b",
        "--sidebar-scrollbar-track-color": "#161a1d",
        "--card-bg-color": "#f8f9fa",
        "--card-border-color": "#ba181b",
        "--card-shadow": "rgba(186, 24, 27, 0.2) 0px 3px 10px",
        "--button-bg-color": "#ba181b",
        "--button-border-color": "#ba181b",
        "--button-text-color": "#f8f9fa",
        "--button-hover-bg": "#e5383b",
        "--button-hover-text-color": "#f8f9fa",
        "--graph-open-col-fill": "#660708",
      },
    },
  ];

export { predefinedThemes };
